$(function(){
// Fixtures navigation
    $(document).on("click", ".team_results_nav", function(){
        if($(this).hasClass("nav_disabled")){
            return false;
        }
        $("#team_results").css("opacity", "0.2");

        var year = $(this).data("year");
        var team_id = $(this).data("team-id");

        $.get(
            ajaxUrl+"/ajax/getTeamResultsByYear.php",
            {
                year : year,
                team_id : team_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#team_results").html(result.data);
                    $("#team_results").css("opacity", "1");
                }
            }
        );

        return false;
    });

    if($("#merch-first-load").length > 0){
        $('a.category-filter-button[data-category="matchtröjor"]').toggleClass("category-filter-button-selected");
        filterMerchandise();
        $("#merch-first-load").remove();
    }

    $(document).on("change", "#team-season-select", function(){
        var season_id = $("#team-season-select").find(":selected").data("season-id");
        var team_id = $("#team-season-select").find(":selected").data("team-id");
        var season_val = $("#team-season-select").val();

        var merch = JSON.stringify($("#merchandise").html());
        $("#team-wrapper").css("opacity", "0.5");
        $.get(
            ajaxUrl+"/ajax/getTeamBySeason.php",
            {
                season_id : season_id,
                team_id : team_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){

                    // Save the selected season in ls for fetching if a user attempts to go back from eg matchpage
                    Cookies.set('team_select_id', team_id, { expires: 0.01, path: '/' });
                    Cookies.set('team_season_select_val', season_val, { expires: 0.01, path: '/' });

                    //$( '[data-toggle="tab"][href="#standing"]' ).trigger( 'click' );
                    $("#team-wrapper").replaceWith(result.data);
                    $("#merchandise").html(JSON.parse(merch));
                    $("#team-wrapper").css("opacity", "1");
                    /*if(result.hide_matches_tabs == 1){
                        $('li a[href="#matches"]').parent().hide();

                    } else {
                        $('li a[href="#matches"]').parent().show();
                    }
                    if(result.hide_results_tabs == 1){
                        $('li a[href="#results"]').parent().hide();
                    } else {
                        $('li a[href="#results"]').parent().show();
                    }
                    var liCount = $('.league_menu li:visible').length;
                    if(liCount == 3){
                        $('.league_menu li:visible').css('flex', '0 0 33.33%');
                    }
                    if(liCount == 4){
                        $('.league_menu li:visible').css('flex', '0 0 25%');
                    }
                    if(liCount == 5){
                        $('.league_menu li:visible').css('flex', '0 0 20%');
                    }*/
                    if($("#rotate-device").length){
                        setTimeout(function(){ $("#rotate-device").fadeOut(); }, 2000);
                    }
                    $("#rotate-device").click(function(){
                        $(this).fadeOut();
                    });
                }
            }
        );
    });

    if($("#team-template").length > 0){
        var cookieTeam = Cookies.get('team_select_id');

        if(cookieTeam != undefined){
            var cookieSeason = Cookies.get('team_season_select_val');
            if(cookieTeam == $("#team-template").data('team-id')){
                if(cookieSeason != $("#team-template").data('season-id')){
                    $("#team-season-select").val(cookieSeason).trigger('change');
                }
            }
        }
    }

    $(document).on("click", ".category-filter-button", function(){
        $(this).toggleClass("category-filter-button-selected");
        filterMerchandise();
        return false;
    });

    /*if($(".team-player-image").length > 0){
        $(".team-player-image").each(function(){
            if($(this) != undefined){
                var image = $(this);
                if(image != undefined){
                    if(image.context.naturalWidth == 0 ||
                        image.readyState == 'uninitialized'){
                        $(image).unbind("error").attr(
                            "src", "https://cdn.sportmonks.com/images/soccer/placeholder.png"
                        );
                    }
                }
            }
        });
    }*/''

    /*$(document).on("click", ".league_menu > li > a", function () {
        $('html, body').css({height: 'auto'}).animate({
            scrollTop: 400
        }, 500).css({height: '100%'});
        return false;
    });*/

    if($("#products").length > 0){
        localStorage.removeItem("productfilter_sub_category");
        localStorage.removeItem("productfilter_gender");
        localStorage.removeItem("productfilter_size");
        localStorage.removeItem("productfilter_brand");
    }
    $(document).on("click", ".product-filter-button", function(){
        $(this).toggleClass("product-filter-button-selected");

        var field = $(this).data("field");
        var values = "";
        $(".product-filter-button[data-field='" + field + "']").each(function(){

            if($(this).hasClass("product-filter-button-selected")){
                values += '"' + $(this).data("value") + '",';
            }
        });

        if(values == ""){
            localStorage.removeItem("productfilter_"+field);
        } else {
            localStorage.setItem("productfilter_"+field, values);
        }

        filterProducts();

        return false;
    });

    $(document).on("click", ".tl_league", function(){
        $(".tl_league").not($(this)).removeClass("fp_league_active");
        $(this).addClass("fp_league_active");
        let league_id = $(this).data("league-id").toString();
        $(".tl-obj").fadeOut();
        $(".tl-obj").each(function(){
            if(league_id.indexOf(',') > -1){
                let aLeagues = league_id.split(',');
                aLeagues.forEach((league) => {
                    if ($(this).attr("data-league-id") == league) {
                        $(this).fadeIn();
                    }
                });
            } else {
                if($(this).attr("data-league-id") == league_id){
                    $(this).fadeIn();
                }
            }
        });
        return false;
    });

    $(document).on("click", ".category-filter-show-more", function(){
        $(".btn-hidden").css("display", "inline-block");
        $(this).hide();
        return false;
    });

    $(document).on("change", ".product-sort", function() {
        filterProducts();
    });
    $(document).on("change", ".shoes_select", function() {
        filterProducts();
    });

    $(document).on("click", "a.filter-heading", function(){
        $(this).next().slideToggle();
        return false;
    });

    $(document).on("click", ".filter_clear", function(){
        localStorage.removeItem("productfilter_sub_category");
        localStorage.removeItem("productfilter_gender");
        localStorage.removeItem("productfilter_size");
        localStorage.removeItem("productfilter_brand");
        if($(".shoes_select").length > 0){
            $(".shoes_select").val("");
        }
        $(".product-filter-button").each(function(){
            $(this).removeClass("product-filter-button-selected");
        });
        filterProducts();
    });

    $(document).on("change", "#team-standing-season-select", function(){
        var season_id = $("#team-standing-season-select").find(":selected").data("season-id");
        var league_id = $("#team-standing-season-select").find(":selected").data("league-id");
        var team_id   = $("#team_id").val();
        $.get(
            ajaxUrl+"/ajax/getStandingBySeason.php",
            {
                season_id : season_id,
                league_id : league_id,
                team_id   : team_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#team-season-standing").replaceWith(result.data);
                    $(".league-img").replaceWith(result.league_logo);
                    $(".league-name").replaceWith(result.league_link);
                }
            }
        );
    });

    $(document).on("click", ".player_modal", function(){
        var player_id = $(this).data("player-id");
        var team_id = $(this).data("team-id");
        var shirt_number = $(this).data("shirt");
        $.post(
            ajaxUrl+"/ajax/getPlayerstatsById.php",
            {
                player_id : player_id,
                team_id : team_id,
                shirt_number : shirt_number
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    /*BootstrapDialog.show({
                        title: 'Visa spelare',
                        message: result.data,
                        nl2br: false
                    });*/
                }
            }
        );
    });
    $(document).on("click", ".player-load-stats", function(){
        if($("#content-" + $(this).data("player-id")).data('loaded') == 0) {
            $("#content-" + $(this).data("player-id")).fadeIn();
            $(this).parent().parent().addClass("player-card-open");
            var player_id = $(this).data("player-id");
            var team_id = $(this).data("team-id");
            var shirt_number = $(this).data("shirt");
            $.get(
                ajaxUrl + "/ajax/getPlayerstatsById.php",
                {
                    player_id: player_id,
                    team_id: team_id,
                    shirt_number: shirt_number
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success == true) {
                        $("#content-" + result.player_id).html(result.data);
                        $("#content-" + result.player_id).data('loaded', 1);
                    }
                }
            );
        } else {
            var el = $(this).parent().parent();
            $("#content-" + $(this).data("player-id")).fadeToggle("fast", function(){
                el.toggleClass("player-card-open");
            });
        }
    });

    $(document).on("click", ".playerstats-pill", function() {
        $(this).addClass('active');
        $('.playerstats-pill[data-season="' + $(this).data('season') +'"]').not($(this)).removeClass('active');
        var target = $(this).data('target');
        $('.pm_extended_stats_table[data-season="'+ $(this).data('season') +'"]').removeClass('active');
        $('.pm_extended_stats_table[data-id="' + target + '"').addClass('active');
    });

    $(document).on("click", ".pm_show_prev_seasons", function(){
        $(".pm_prev_seasons").fadeToggle();
        return false;
    });
    $(document).on("click", ".pm_show_more_stats", function(){
        var season_id = $(this).data("season-id");
        $(".pm_row_hidden[data-season-holder='" + season_id + "']").fadeToggle();
        return false;
    });

});

function filterMerchandise(){
    if($(".category-filter-button-selected").length > 0){
        $(".product-title").hide();
        $(".products-flex").hide();
        $(".category-filter-button-selected").each(function(i){
            var category = $(this).attr("data-category");
            $(".product-title").each(function(){
                if($(this).attr("data-category") == category){
                    $(this).show();
                }
            });
            $(".products-flex").each(function(){
                if($(this).attr("data-category") == category){
                    $(this).show();
                }
            });
        });
    } else {
        $(".product-title").show();
        $(".products-flex").show();
    }
}
function filterProducts(){
    $("#products").css("opacity", "0.2");

    var category = $("#product_type").val();
    var sub_category = localStorage.getItem("productfilter_sub_category");
    var gender = localStorage.getItem("productfilter_gender");
    if($(".shoes_select").length > 0){
        var size = $(".shoes_select").val();
    } else {
        var size = localStorage.getItem("productfilter_size");
    }
    var brand = localStorage.getItem("productfilter_brand");
    var order = $(".product-sort").val();

    $.get(
        ajaxUrl+"/ajax/filterProducts.php",
        {
            category : category,
            sub_category : sub_category,
            gender : gender,
            size : size,
            brand : brand,
            order : order
        },
        function(data){
            var result = $.parseJSON(data);
            if(result.success == true){
                if(result.count > 0){
                    $("#products").html(result.html).removeClass("products-empty");
                } else {
                    $("#products").html("Inga produkter matchar din filtrering.").addClass("products-empty");
                }

                $("#products_count").html(result.count);
                $("#products").css("opacity", "1");
            }
        }
    );
}